import request from '@/utils/request'
// 出口订单报文
const requestApi = {
  e_ceb303_import_list: '/e/ceb303/import/',
  e_ceb303_import_excel_list: '/e/ceb303/import/excel/',
  e_ceb303_import_excel_create: '/e/ceb303/import/excel/',
  e_ceb303_import_partial_update: '/e/ceb303/import/',
  e_ceb303_order_list: '/e/ceb303/order/',
  e_ceb303_order_partial_update: '/e/ceb303/order/',
  e_ceb303_order_status_list: '/e/ceb303/order/',
  e_ceb303_order_delete: '/e/ceb303/order/'
}

export function e_ceb303_import_list (query) {
  return request({
    url: requestApi.e_ceb303_import_list,
    method: 'get',
    params: query
  })
}
export function e_ceb303_import_excel_list (query) {
  return request({
    url: requestApi.e_ceb303_import_excel_list,
    method: 'get',
    params: query,
    responseType: 'blob'
  })
}
export function e_ceb303_order_list (query) {
  return request({
    url: requestApi.e_ceb303_order_list,
    method: 'get',
    params: query
  })
}
export function e_ceb303_order_status_list (query, id) {
  return request({
    url: requestApi.e_ceb303_order_status_list + id + '/status/',
    method: 'get',
    params: query
  })
}
export function e_ceb303_import_excel_create (data) {
  return request({
    url: requestApi.e_ceb303_import_excel_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data
  })
}

export function e_ceb303_import_partial_update (data, id) {
  return request({
    url: requestApi.e_ceb303_import_partial_update + id + '/',
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}
export function e_ceb303_order_partial_update (data, id) {
  return request({
    url: requestApi.e_ceb303_order_partial_update + id + '/',
    method: 'PATCH',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: data
  })
}
/**
 * 删除
 */
export function e_ceb303_order_delete (id) {
  return request({
    url: requestApi.e_ceb303_order_delete + id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
